import React from 'react';

const Footer = () => {
    return (
        <>
            <style>{`
        .app-footer {
          background: var(--card-bg);
          border-top: 1px solid var(--border-color);
          padding: 24px 0;
          margin-top: auto;
        }
        
        .app-footer-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
        }
        
        .app-footer-email {
          color: var(--text-secondary);
          font-size: 14px;
          margin: 0;
        }
        
        .app-footer-email a {
          color: #6366f1;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s ease;
        }
        
        .app-footer-email a:hover {
          color: #4f46e5;
          text-decoration: underline;
        }
        
        .app-footer-links {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
          justify-content: center;
        }
        
        .app-footer-link {
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 13px;
          transition: color 0.2s ease;
        }
        
        .app-footer-link:hover {
          color: #6366f1;
        }
        
        .app-footer-badges {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 12px;
        }
        
        .app-footer-badges a {
          display: inline-flex;
          opacity: 0.85;
          transition: opacity 0.2s ease, transform 0.2s ease;
        }
        
        .app-footer-badges a:hover {
          opacity: 1;
          transform: translateY(-1px);
        }
        
        .app-footer-copyright {
          color: var(--text-muted);
          font-size: 12px;
          margin: 0;
        }
        
        @media (max-width: 768px) {
          .app-footer {
            padding: 20px 0;
          }
          
          .app-footer-container {
            padding: 0 16px;
          }
          
          .app-footer-links {
            gap: 16px;
          }
        }
      `}</style>

            <footer className="app-footer">
                <div className="app-footer-container">
                    <p className="app-footer-email">
                        Support: <a href="mailto:admin@apiloadtest.com">admin@apiloadtest.com</a>
                    </p>
                    <div className="app-footer-links">
                        <a
                            href="https://docs.google.com/document/d/13xfhZnRwRMnubtFWpiB5t1rbiRSPTeXCoyGjYCPqo6A/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="app-footer-link"
                        >
                            Privacy Policy
                        </a>
                        <a href="mailto:admin@apiloadtest.com" className="app-footer-link">
                            Contact Us
                        </a>
                    </div>
                    <div className="app-footer-badges">
                        <a href="https://startupfa.me/s/apiloadtest?utm_source=www.apiloadtest.com" target="_blank" rel="noopener noreferrer">
                            <img src="https://startupfa.me/badges/featured-badge-small.webp" alt="ALT - APILoadTest - Featured on Startup Fame" width="224" height="36" />
                        </a>
                    </div>
                    <p className="app-footer-copyright">
                        © 2025 APILoadTest.com. All rights reserved.
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
